import React from 'react';
import { useTranslation } from 'react-i18next';
import { getI18nValue } from 'utils/Utils';
import PropTypes from 'prop-types';

const selectClass = "text-sm border border-gray-300 rounded pl-2 pr-7 py-1.5 text-gray-600 bg-white cursor-pointer focus:outline-none focus:ring-1 focus:ring-blue-400";

function LanguageSelect({ value, onChange }) {
    const { t } = useTranslation();

    return (
        <select value={value} onChange={(e) => onChange(e.target.value)} className={selectClass}>
            <option value="">{t(getI18nValue('analytics.kpi.filters', 'all_languages'))}</option>
            <option value="fr">Français</option>
            <option value="ar">العربية</option>
            <option value="darija">Darija</option>
            <option value="en">English</option>
        </select>
    );
}

LanguageSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default LanguageSelect;
